// extracted by mini-css-extract-plugin
export default {"list_item_padding_left_right":"14px","list_item_padding_top_bottom":"16.5px"};